module.exports = __webpack_public_path__ + "img/interreg-cedaci-logo.abbc9626.png";